import { request } from '@/utils/api/request';

import { PROFILE_TYPE } from '@/constants/profiles';
import { ENDPOINT } from '@/constants/api';

export const profiles = {
  connectListings({ listings, profileId, signal, type }) {
    return request.post({
      endpoint: ENDPOINT.WEB_V3,
      payload: { product_ids: listings },
      signal,
      url: type === PROFILE_TYPE.AI
        ? `/profiles/ai/${profileId}/connect`
        : `/profiles/${profileId}/connect`,
    });
  },
  createProfile({ db, payload, shopId, signal, type }) {
    return request.post({
      endpoint: ENDPOINT.WEB_V3,
      params: { db },
      payload,
      signal,
      url: type === PROFILE_TYPE.AI
        ? `/profiles/ai/shops/${shopId}`
        : `/profiles/shops/${shopId}`,
    });
  },
  deleteProfile({ profileId, signal, type }) {
    return request.delete({
      endpoint: ENDPOINT.WEB_V3,
      signal,
      url: type === PROFILE_TYPE.AI
        ? `/profiles/ai/${profileId}`
        : `/profiles/${profileId}`,
    });
  },
  disconnectListings({ listings, profileId, signal, type }) {
    return request.post({
      endpoint: ENDPOINT.WEB_V3,
      payload: { product_ids: listings },
      signal,
      url: type === PROFILE_TYPE.AI
        ? `/profiles/ai/${profileId}/disconnect`
        : `/profiles/${profileId}/disconnect`,
    });
  },
  getById({ profileId, signal, type }) {
    return type === PROFILE_TYPE.AI
      ? request.get({
        endpoint: ENDPOINT.WEB_V3,
        signal,
        url: `/profiles/ai/${profileId}`,
      })
      : Promise.reject(`API endpoint is not defined for type "${type}"`);
  },
  getFilters({ db, shopId, signal, type }) {
    return request.get({
      endpoint: ENDPOINT.WEB_V3,
      params: { db },
      signal,
      url: type === PROFILE_TYPE.AI
        ? `/profiles/ai/shops/${shopId}/filters`
        : `/profiles/shops/${shopId}/filters`,
    });
  },
  getListings({ limit, offset, profileId, signal, type }) {
    return request.get({
      endpoint: ENDPOINT.WEB_V3,
      params: { limit, offset },
      signal,
      url: type === PROFILE_TYPE.AI
        ? `/profiles/ai/${profileId}/products`
        : `/profiles/${profileId}/products`,
    });
  },
  getProfiles({ db, limit, name, offset, section, shopId, signal, type }) {
    return request.get({
      endpoint: ENDPOINT.WEB_V3,
      params: { db, limit, name, offset, section },
      signal,
      url: type === PROFILE_TYPE.AI
        ? `/profiles/ai/shops/${shopId}`
        : `/profiles/shops/${shopId}`,
    });
  },
  partialUpdateProfile({ payload, profileId, signal, type }) {
    return request.patch({
      endpoint: ENDPOINT.WEB_V3,
      payload,
      signal,
      url: type === PROFILE_TYPE.AI
        ? `/profiles/ai/${profileId}`
        : `/profiles/${profileId}`,
    });
  },
  propagateProfile({ payload, profileId, signal, type }) {
    return request.post({
      endpoint: ENDPOINT.WEB_V3,
      payload,
      signal,
      url: type === PROFILE_TYPE.AI
        ? `/profiles/ai/${profileId}/propagate`
        : `/profiles/${profileId}/propagate`,
    });
  },
  updateProfile({ payload, profileId, signal, type }) {
    return request.put({
      endpoint: ENDPOINT.WEB_V3,
      payload,
      signal,
      url: type === PROFILE_TYPE.AI
        ? `/profiles/ai/${profileId}`
        : `/profiles/${profileId}`,
    });
  },
};
